module.exports = "<button class=\"button\" (click)=\"openSidenavMobile()\" mat-icon-button fxHide.gt-md>\n  <mat-icon>menu</mat-icon>\n</button>\n"